import { FlowObsoleteBlockType } from 'flow-schema';

import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import { BlockType, SpecialBlockType, UnknownBlockType } from '../base/baseSchema.js';

export const BASE_FLOW_BLOCK_TYPE_COMPATIBILITY: FlowDefinitionBlockCompatibilityByBlockType = {
  [BlockType.Start]: FlowDefinitionBlockTypeCompatibility.Required,
  [BlockType.Output]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SubFlowV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.IteratorV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Repeat]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Conditional]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Switch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ScriptedFlow]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Text]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FilterList]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.UpdateFlowConfig]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.LlmPrompt]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Evaluation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.MedicalNecessityCheck]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Fhir]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.OcrV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.InformationExtraction]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.VoiceCallV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.VoiceTranscribe]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HieQueryDocuments]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HieGetDocuments]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitForFormCompletion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Conversation]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.AdvancedFhir]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HCCAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentTemplate]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GenerateFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.PatientDataStore]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Rest]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Form]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FormV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetFormSet]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetInsurances]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SendEmail]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.SendSms]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Fax]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.HumanTask]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.UpdateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Hl7]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Mirth]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.MontageOnBase]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.RealTimeEligibility]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.InsuranceCard]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.FileConversion]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.WaitForSignal]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.Callback]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CareGapAlgorithmBlock]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentExtract]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetPatient]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetPatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetProvider]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ExportExternalDocumentPacket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ExportTextToBucket]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreateEncounterSummary]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreatePatientOrder]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.AsynchronousExportJob]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.CreateNotableObject]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.DocumentSearch]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.GetSftpFile]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [BlockType.ServiceReview]: FlowDefinitionBlockTypeCompatibility.Allowed,
  [SpecialBlockType.SkillV2]: FlowDefinitionBlockTypeCompatibility.Allowed,
  // Retired blocks
  [BlockType.AuthorizationSubmission]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.Wait]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.IteratorV1]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.SubFlowV1]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.VoiceCall]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.Ocr]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.RestApiClassicAuthorization]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.Scheduling]: FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  [BlockType.AsynchronousExtractJob]:
    FlowDefinitionBlockTypeCompatibility.ConditionallyAllowedRetiredBlock,
  // Obsolete blocks
  [FlowObsoleteBlockType.ObsoleteApiSubmissions]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteGetEncounterSummary]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteHumanReview]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSkill]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteSendToLabelboxForReview]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [FlowObsoleteBlockType.ObsoleteWaitForAvailableSchedulingSlot]:
    FlowDefinitionBlockTypeCompatibility.NotAllowed,
  [UnknownBlockType.Unknown]: FlowDefinitionBlockTypeCompatibility.NotAllowed,
};
